module.exports = __webpack_public_path__ + "static/media/ARLTUG.8529370b.png";